import { X, Check } from "lucide-react";

const ROWS = [
    { dim: "Intake & handoffs", before: "Spreadsheet handoffs", after: "AI-assisted intake" },
    { dim: "Sourcing & matching", before: "Vendor chasing", after: "Matched outputs" },
    { dim: "Verification & review", before: "Manual reviews", after: "Human review gates" },
    { dim: "Tooling & visibility", before: "Disconnected tools", after: "SLA visibility" },
    { dim: "Speed & approvals", before: "Slow approvals", after: "Productized accelerators" },
    { dim: "Delivery & ownership", before: "No clear delivery owner", after: "Accountable delivery" },
];

export default function BeforeAfter() {
    return (
        <section className="pqx-section bg-[#FAFAF8]" data-testid="home-before-after">
            <div className="pqx-container">
                <div className="max-w-3xl mb-10 md:mb-12">
                    <span className="pqx-eyebrow">Before vs after</span>
                    <h2 className="pqx-h2 mt-4 text-[#303030]">
                        The same operation — without us, then with us.
                    </h2>
                    <p className="mt-5 text-[#303030]/70 text-base md:text-lg leading-relaxed max-w-2xl">
                        AI only matters if it changes the numbers. Here's what shifts when an
                        Perceptiqx operating layer goes live inside a real workflow.
                    </p>
                </div>

                <div className="grid lg:grid-cols-2 gap-4 md:gap-5">
                    {/* Before */}
                    <div
                        className="rounded-3xl border border-[#303030]/10 bg-white p-6 md:p-8"
                        data-testid="before-column"
                    >
                        <div className="flex items-center gap-3">
                            <span className="w-9 h-9 grid place-items-center rounded-xl bg-[#303030]/8 text-[#303030]/60">
                                <X className="w-5 h-5" />
                            </span>
                            <div>
                                <p className="text-[11px] uppercase tracking-[0.18em] text-[#303030]/45 font-semibold">Before</p>
                                <p className="text-[15px] font-semibold text-[#303030]">Manual, fragmented, hard to scale</p>
                            </div>
                        </div>
                        <ul className="mt-6 space-y-4">
                            {ROWS.map((r) => (
                                <li key={r.dim} className="border-t border-[#303030]/6 pt-4 first:border-0 first:pt-0">
                                    <p className="text-[11px] uppercase tracking-[0.14em] text-[#303030]/45">{r.dim}</p>
                                    <p className="mt-1 text-[14px] text-[#303030]/65">{r.before}</p>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* After */}
                    <div
                        className="relative rounded-3xl p-6 md:p-8 overflow-hidden pqx-dark-panel"
                        data-testid="after-column"
                    >
                        <div className="absolute inset-0 pqx-grid-bg-dark opacity-30" />
                        <div className="relative">
                            <div className="flex items-center gap-3">
                                <span className="w-9 h-9 grid place-items-center rounded-xl bg-[#FF4040] text-white">
                                    <Check className="w-5 h-5" />
                                </span>
                                <div>
                                    <p className="text-[11px] uppercase tracking-[0.18em] text-[#FF4040] font-semibold">After Perceptiqx</p>
                                    <p className="text-[15px] font-semibold text-white">Instrumented, automated, compounding</p>
                                </div>
                            </div>
                            <ul className="mt-6 space-y-4">
                                {ROWS.map((r) => (
                                    <li key={r.dim} className="border-t border-white/10 pt-4 first:border-0 first:pt-0">
                                        <p className="text-[11px] uppercase tracking-[0.14em] text-white/45">{r.dim}</p>
                                        <p className="mt-1 text-[14px] text-white font-medium">{r.after}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
